import { cva } from "cva";

export const faqContainerStyle = cva("", {
  defaultVariants: {
    appearance: "light",
  },
  variants: {
    appearance: {
      brand: "bg-brand-indigo",
      dark: "bg-gray-900",
      light: "bg-white",
    },
  },
});

export const faqHeadlineStyles = cva("", {
  defaultVariants: {
    appearance: "light",
  },
  variants: {
    appearance: {
      brand: "text-white",
      dark: "text-white",
      light: "text-gray-900",
    },
  },
});

export const faqQuestionStyle = cva("", {
  defaultVariants: {
    appearance: "light",
  },
  variants: {
    appearance: {
      brand: "text-white",
      dark: "text-white",
      light: "text-gray-900",
    },
  },
});
export const faqAnswerStyle = cva("", {
  defaultVariants: {
    appearance: "light",
  },
  variants: {
    appearance: {
      brand: "text-gray-100",
      dark: "text-gray-100",
      light: "text-gray-700",
    },
  },
});

export const faqIconColorStyle = cva("ml-6 flex h-7 items-center", {
  defaultVariants: {
    appearance: "light",
  },
  variants: {
    appearance: {
      brand: "text-gray-100",
      dark: "text-gray-100",
      light: "text-gray-900",
    },
  },
});

export const faqDividerStyle = cva("", {
  defaultVariants: {
    appearance: "light",
  },
  variants: {
    appearance: {
      brand: "divide-y divide-white/20",
      dark: "divide-y divide-white/20",
      light: "divide-y divide-black/20",
    },
  },
});
